export default "__VITE_ASSET__CSfVy4AV__"